type Subscriber<T> = (arg: T) => void

const createSubscriptionManager = <T>() => {
  const subscribers: Subscriber<T>[] = []

  return {
    subscribe: (subscriber: Subscriber<T>) => {
      subscribers.push(subscriber)
    },
    unsubscribe: (subscriber: Subscriber<T>) => {
      const index = subscribers.indexOf(subscriber)
      if (index !== -1) {
        subscribers.splice(index, 1)
      }
    },
    notify: (arg: T) => {
      subscribers.forEach((subscriber) => subscriber(arg))
    },
  }
}

const newTrackManager = createSubscriptionManager<MediaStreamTrack>()
const removedTrackManager = createSubscriptionManager<MediaStreamTrack>()

// subscribe
const subscribeOnTrackAdded = newTrackManager.subscribe
const subscribeOnTrackRemoved = removedTrackManager.subscribe
// unsubscribe
const unsubscribeOnNewTrackAdded = newTrackManager.unsubscribe
const unsubscribeOnTrackRemoved = removedTrackManager.unsubscribe
// notify
const notifyTrackAdded = newTrackManager.notify
const notifyTrackRemoved = removedTrackManager.notify

export {
  subscribeOnTrackAdded,
  subscribeOnTrackRemoved,
  unsubscribeOnNewTrackAdded,
  unsubscribeOnTrackRemoved,
  notifyTrackAdded,
  notifyTrackRemoved,
}
